<template>
  <div class="container">
  <div class="table-responsive" data-v-6d87bdb4="">
    <table class="table table-bordered table-hover table-striped table-dark border border-dark shadow-lg" id="dataTable" width="100%" cellspacing="0" data-v-6d87bdb4="">
      <thead data-v-6d87bdb4="">
      <tr data-v-6d87bdb4="">
        <th class="post"> <div class="line"></div></th>
        <th  class="post"><div class="line"></div></th>
        <th  class="post"><div class="line"></div></th>
        <th  class="post"><div class="line"></div></th>
      </tr>
      </thead>

      <tbody >
      <tr>
        <td class="post"><div class="line"></div></td>
        <td class="post"><div class="line"></div></td>
        <td class="post"><div class="line"></div></td>
        <td class="post"><div class="line"></div></td>
      </tr>
      </tbody>
    </table>
  </div>

  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped>
body {
  margin: 0;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.post {
  width: 55px;
  height: 80px;
}
.post .line {
  float: left;
  width: 100%;
  height: 16px;
  background-image: linear-gradient(90deg, rgba(46,51,56, 0.1) 0px, rgba(46,51,56, 1) 40px, rgba(46,51,56, 1) 80px);
  background-size: 600px;
  animation: shine-lines 2s infinite ease-out;
}
.post .avatar + .line {
  width: 100px;
}
.post .line ~ .line {
  background-color: #ddd;
}

@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%, 100% {
    background-position: 140px;
  }
}
@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 208px;
  }
}

</style>
